export const getStatusFromApiError = (error) => {
    return error.status ?? error.response?.status;
};
